import * as MetaReducers from './participant-verification.metareducer';
import * as Reducers from './participant-verification.reducer';

export const ParticipantVerificationReducers = {
  Reducers,
  MetaReducers,
};
